import { render, staticRenderFns } from "./CommentFeed.vue?vue&type=template&id=3fb5d8bc&"
import script from "./CommentFeed.vue?vue&type=script&lang=ts&"
export * from "./CommentFeed.vue?vue&type=script&lang=ts&"
import style0 from "./CommentFeed.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports